import {Injectable} from '@angular/core';
import {
	CanActivate, Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateChild,
	CanLoad, Route, UrlSegment, UrlTree
} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {Observable} from 'rxjs';
import {PortalBootstrapService} from '../services/portal-bootstrap.service';
import {Auth0ClientService} from '../services/auth0-client.service';

@Injectable({providedIn: 'root'})
export class UnAuthenticatedGuard implements CanActivate, CanActivateChild, CanLoad {
	constructor(
		private authService: AuthenticationService,
		private router: Router,
		private portalBootstrap: PortalBootstrapService,
		private auth0Client: Auth0ClientService
	) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const url = `/${state.url}`;
		const teamId = route.parent.paramMap.get('team');
		const redirectUrl = `${teamId}/main`;
		return this.loadAuthenticationChecker(url, redirectUrl, teamId);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.canActivate(childRoute, state);
	}

	canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
		const url = `/${route.path}`;
		const teamCodePath = segments[0].path;
		const redirectUrl = `${teamCodePath}/main`;
		return this.loadAuthenticationChecker(url, redirectUrl, teamCodePath);
	}

	private async loadAuthenticationChecker(url: string, redirectUrl: string, teamCodePath: string): Promise<boolean> {
		if (this.portalBootstrap.auth0Enabled) {
			const isAuthenticated = await this.auth0Client.isAuthenticated();
			if (isAuthenticated) {
				this.router.navigate([redirectUrl]);
				return false;
			}
			return true;
		}

		if (this.authService.isLoggedInPortal(teamCodePath)) {
			this.router.navigate([redirectUrl]);
			return false;
		}
		return true;
	}
}
